<template>
  <div class="last-card">
    <div>
      <h1>
        {{ $t("done!") }}
      </h1>
      <h3>{{ $t("you learned") }} {{ stackLength }} {{ $t("words") }}</h3>
      <div>
        <h3>
          <router-link :to="{ name: 'box-quiz', params: { id: boxId } }">
            {{ $t("take quiz") }}
          </router-link>
        </h3>
        <h3 @click="$emit('redoBox')">
          {{ $t("redo box") }}
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "LastCard",
  props: {
    stackLength: {
      type: Number,
      required: true
    },
    boxId: {
      type: Number,
      required: true
    },
    firstCardId: {
      type: Number,
      required: true
    }
  },
  methods: {
    ...mapActions("vokabel", ["boxStateIncrementSeenCount", "BoxStateUpdate"])
  },
  created() {
    this.boxStateIncrementSeenCount({ box_id: this.boxId });
    this.BoxStateUpdate({ cardId: this.firstCardId, boxId: this.boxId });
  }
};
</script>

<style lang="scss">
.last-card {
  display: flex;
  align-items: center;
  align-content: center;
  align-self: center;
  height: 100%;
  height: 425px;
  justify-content: center;
  flex-direction: column;
  width: 100%;
}
</style>
